import { render, staticRenderFns } from "./DoctorFilter.vue?vue&type=template&id=4210b3f9&"
import script from "./DoctorFilter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorFilter.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4210b3f9')) {
      api.createRecord('4210b3f9', component.options)
    } else {
      api.reload('4210b3f9', component.options)
    }
    module.hot.accept("./DoctorFilter.vue?vue&type=template&id=4210b3f9&", function () {
      api.rerender('4210b3f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/memorial/MemoryBoardPage/components/DoctorFilter/DoctorFilter.vue"
export default component.exports